import { Controller } from "@hotwired/stimulus"

// Add and remove unit rows on the food form ("slice — 40 g").
//
// Removal marks _destroy and hides the row rather than deleting the node, so
// a saved unit is actually destroyed server-side; a brand-new row has no
// persisted record and is removed outright.
export default class extends Controller {
  static targets = ["list", "template", "row"]

  add(event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now())
    this.listTarget.insertAdjacentHTML("beforeend", html)

    const row = this.listTarget.lastElementChild
    this.#applyMeasure(row)
    row?.querySelector("input[type=text]")?.focus()
  }

  // A TEMPLATE IS FROZEN AT PAGE LOAD. Its HTML was rendered once, with
  // whatever measure the food had then — "g" on a new food, since a fresh
  // Food has no measured_in yet. measure_toggle updates the rows it can
  // see, and it cannot see inside <template>, so every row cloned after a
  // switch to volume carried "g" while the first said "mL".
  //
  // So the new row is told the CURRENT measure. Read from the checked radio
  // rather than from a row already on the page: a food with no units yet
  // has no row to copy, and that is exactly when the first Add happens.
  //
  // "mL" not "ml" — Food#base_unit_label spells it that way and
  // measure_toggle matches it, because a lowercase l beside a 1 misreads.
  #applyMeasure(row) {
    if (!row) return

    const checked = this.element.querySelector("input[name*='[measured_in]']:checked")
    const measure = checked?.value || "weight"
    const label = measure === "volume" ? "mL" : "g"

    row.querySelectorAll("[data-measure-toggle-target='unit']").forEach((node) => {
      node.textContent = label
    })

    // The suggestion list is filtered by measure too, and unit-picker reads
    // this when it connects — so it has to be right before then.
    const picker = row.querySelector("[data-unit-picker-measure-value]")
    if (picker) picker.dataset.unitPickerMeasureValue = measure
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-units-target='row']")
    const destroyField = row.querySelector("[data-units-target='destroy']")

    if (destroyField && row.querySelector("input[name*='[id]']")) {
      destroyField.value = "1"
      row.style.display = "none"
    } else {
      row.remove()
    }
  }
}
